import { SubscriptionSubscriptionData } from '@/backend-api/Api';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/ui-lib/button';

interface CancelSubscriptionDialogProps {
    open: boolean;
    subscription: SubscriptionSubscriptionData | undefined;
    isLoading: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export function CancelSubscriptionDialog({
    open,
    subscription,
    isLoading,
    onConfirm,
    onCancel,
}: CancelSubscriptionDialogProps) {
    return (
        <Dialog open={open} onOpenChange={(open) => !open && onCancel()}>
            <DialogContent theme="dark" className="max-w-md">
                <DialogHeader>
                    <DialogTitle className="text-neutral-100">Cancel Subscription</DialogTitle>
                    <DialogDescription className="text-neutral-400">
                        Are you sure you want to cancel your subscription to{' '}
                        <strong>{subscription?.displayName}</strong>?
                    </DialogDescription>
                </DialogHeader>

                <div className="space-y-3 py-4">
                    <p className="text-sm text-neutral-300">
                        Your subscription will remain active until the end of the current billing period. You will
                        continue to have access until then.
                    </p>
                    <p className="text-sm text-neutral-400">
                        You can reactivate your subscription at any time before the period ends.
                    </p>
                </div>

                <DialogFooter>
                    <Button variant="secondary" onClick={onCancel} disabled={isLoading} type="button">
                        Keep Subscription
                    </Button>
                    <Button
                        type="button"
                        variant="secondary"
                        onClick={onConfirm}
                        disabled={isLoading}
                        isLoading={isLoading}
                        className="bg-red-600 border-red-600 hover:bg-red-700 hover:border-red-700"
                    >
                        {isLoading ? 'Canceling...' : 'Cancel Subscription'}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
